// Form initial values

export const initialValues = {
    email: '',
    username: '',
    phone: '',
};